<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <DashboardComedorCard @open="open" @close="close"></DashboardComedorCard>
    <div v-if="showLoading" class="progress-background">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'DashboardComedor',

  data: () => ({
    showLoading: false,
    page: {
      title: 'Dashboard'
    },
    breadcrumbs: [
      {
        text: 'Dashboard',
        disabled: true
      },
      {
        text: 'Comedor',
        disabled: true
      }
    ]
  }),
  components: {
    DashboardComedorCard: () => import('../components/DashboardComedorCard')
  },
  methods: {
    open() {
      this.showLoading = true;
    },
    close() {
      this.showLoading = false;
    }
  }
};
</script>
